package com.example.mystybag.core.expected

actual object VibratorHelper {
    actual fun vibrate() {}
}
